var GridFunction;
(function (GridFunction) {
    GridFunction["CALC"] = "calc";
    GridFunction["MINMAX"] = "minmax";
})(GridFunction || (GridFunction = {}));
var GridKeyword;
(function (GridKeyword) {
    GridKeyword["AUTO"] = "auto";
    GridKeyword["MAX_CONTENT"] = "max-content";
    GridKeyword["MIN_CONTENT"] = "min-content";
})(GridKeyword || (GridKeyword = {}));
var GridOperator;
(function (GridOperator) {
    GridOperator["DIVISION"] = "/";
})(GridOperator || (GridOperator = {}));
var GridTrackType;
(function (GridTrackType) {
    GridTrackType["FUNCTION"] = "function";
    GridTrackType["KEYWORD"] = "keyword";
    GridTrackType["LENGTH"] = "length";
})(GridTrackType || (GridTrackType = {}));
export { GridFunction, GridKeyword, GridOperator, GridTrackType, };
//# sourceMappingURL=grid-enums.js.map